var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 561.4 161.2",
    style: {
      enableBackground: "new 0 0 561.4 161.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#F3BA2F;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F3BA2F;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297,133.8V0.1h35.4c25,0,44.4,5.9,58.5,17.9c13.9,12,21,28.4,21,48.9c0,12.5-3,23.4-8.5,33 c-5.5,9.5-13.9,17.5-24.4,24c-5.9,3.4-13,5.9-20,7.4c-7,1.5-16,2.5-27,2.5L297,133.8L297,133.8z M328.4,104.8h7 c13.9,0,25-3.4,33-9.9s12-16,12-28s-4-21.5-12-28s-19-9.9-33-9.9h-7V104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.7,133.8V0.1h32v104.8h52v28.4h-84V133.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,133.9V0.1h31.4v48.9h51.4V0h31.4v133.7H82.9V77.9H31.4v55.8H0V133.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M210.7,3.1c-35.4,0-63.8,28.4-63.8,63.8s28.4,63.8,63.8,63.8s63.8-28.4,63.8-63.8 C274.1,31.6,245.5,3.1,210.7,3.1L210.7,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204.6,3.1c-35.4,0-63.8,28.4-63.8,63.8s28.4,63.8,63.8,63.8s63.8-28.4,63.8-63.8S240,3.1,204.6,3.1L204.6,3.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M194.1,3.1c-35.4,0-63.8,28.4-63.8,63.8s28.4,63.8,63.8,63.8S258,102.4,258,66.9S229.6,3.1,194.1,3.1 L194.1,3.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M545.5,131.4c2.5,0,5.5,0.6,8,1.9c2.5,1.5,4.5,3,5.9,5.5c1.5,2.5,1.9,5,1.9,7.4s-0.6,5-1.9,7.4 c-1.5,2.5-3.4,4.5-5.9,5.5c-2.5,1.5-5,1.9-8,1.9c-3,0-5.5-0.6-8-1.9c-2.5-1.5-4.5-3-5.9-5.5c-1.5-2.5-1.9-5-1.9-7.4s0.6-5,1.9-7.4 s3.4-4.5,5.9-5.5C540,131.8,543.1,131.4,545.5,131.4z M545.5,133.9c-2.5,0-4.5,0.6-6.5,1.5c-1.9,1-4,2.5-5,4.5s-1.9,4-1.9,6.5 c0,1.9,0.6,4,1.9,5.9c1,1.9,3,3.4,5,4.5c1.9,1.1,4.5,1.5,6.5,1.5c2.5,0,4.5-0.6,6.5-1.5c1.9-1,4-2.5,5-4.5c1-1.9,1.9-4,1.9-5.9 c0-1.9-0.6-4.5-1.9-6.5c-1-1.9-3-3.4-5-4.5C550.1,134.3,547.6,133.9,545.5,133.9z M538.5,154.8v-16h5.9c1.9,0,3.4,0,4.5,0.6 c1,0.6,1.5,1,1.9,1.5c0.6,0.6,1,1.5,1,2.5s-0.6,1.9-1.5,3c-1,1-1.9,1.5-3.4,1.5c0.6,0,1,0.6,1.5,1c0.6,0.6,1.5,1.5,2.5,3l1.9,3 h-3.4l-1.5-2.5c-1-1.9-1.9-3.4-3-4c-0.6-0.6-1.5-0.6-1.9-0.6h-1.5v7L538.5,154.8L538.5,154.8z M541.1,145.3h3.4 c1.5,0,2.5,0,3.4-0.6c0.6-0.6,1-1,1-1.9c0-0.6,0-1-0.6-1.5c-0.6-0.6-0.6-0.6-1-1c-0.6,0-1.5-0.6-3-0.6h-3v5.5L541.1,145.3 L541.1,145.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.354c011c33369d554e3b4f38d0457900.svg";
export { ForwardRef as ReactComponent };